import { Outlet, useParams } from 'react-router-dom'

import useGetObject from '@app/hooks/useGetObject'
import Header from '@app/pages/strategies/components/header'
import { PageStack } from '@app/shared/layout'
import withAwait from '@app/shared/withAwait'

const DrawerShow = () => {
  const { nodeId } = useParams()

  const strategy = useGetObject(nodeId, 'strategy')

  if (!strategy) {
    return null
  }

  return (
    <PageStack bg="bg">
      <Header strategy={strategy} />
      <Outlet />
    </PageStack>
  )
}

export default withAwait(DrawerShow, 'strategy')
